<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 510.998 510.998" style="enable-background:new 0 0 510.998 510.998;" xml:space="preserve">
  <g>
		<ellipse :style="{'fill': circleFill}" cx="255.499" cy="255.499" rx="249.283" ry="255.499"/>
  </g>
  <g>
    <path style="fill:#ECF0F0;" d="M380.611,309.313c53.039-54.36,53.061-142.474,0.022-196.836s-139.065-54.395-192.103-0.035
    c-48.124,49.324-52.362,126.679-13.411,180.894l-41.972,43.019c-3.013,3.09-3.073,8.342-0.059,11.43l17.731,18.176
    c3.014,3.088,7.959,2.842,10.974-0.247l41.933-42.977C256.962,363.243,332.393,358.735,380.611,309.313z"/>
    <path style="opacity:0.3;fill:#5D5D5D;enable-background:new    ;" d="M133.788,336.355c-3.014,3.09-3.392,8.342-0.381,11.43
    l17.573,18.176c3.014,3.088,8.52,2.842,11.535-0.247l8.136-7.766v-58.72L133.788,336.355z"/>
    <path style="fill:#76BED6;" d="M356.926,285.038c-39.933,40.93-104.677,40.93-144.61,0c-39.932-40.929-39.932-107.287,0.002-148.214
    c39.932-40.929,104.675-40.929,144.608,0C396.858,177.75,396.858,244.109,356.926,285.038z"/>
    <path style="fill:#83D2ED;" d="M216.863,280.379c-37.361-38.295-37.361-100.602,0-138.894
    c37.361-38.295,98.154-38.296,135.516-0.002c37.361,38.294,37.361,100.602,0,138.897
    C315.017,318.673,254.224,318.673,216.863,280.379z"/>
    <path style="fill:#FBFFFF;" d="M371.196,116.788c-21.564-19-48.408-30.129-76.79-31.891c-28.047-1.742-56.522,6.565-79.616,22.903
    c-5.086,3.597-0.35,12.216,4.764,8.598c21.492-15.204,47.029-22.761,73.116-21.705c26.238,1.062,51.822,11.564,71.706,29.085
    C369.064,127.907,375.917,120.947,371.196,116.788L371.196,116.788z"/>
    <path style="fill:#B0EBFF;" d="M353.047,263.61c-15.567,15.955-40.807,15.955-56.374,0c-15.567-15.956-15.567-41.822,0-57.778
    c15.567-15.957,40.807-15.957,56.374,0C368.614,221.788,368.614,247.654,353.047,263.61z"/>
    <path style="fill:#B0EBFF;" d="M351.238,176.026c-4.273,4.378-11.199,4.378-15.471-0.002c-4.272-4.378-4.272-11.476,0-15.855
    c4.272-4.379,11.198-4.379,15.47,0.002C355.508,164.549,355.51,171.647,351.238,176.026z"/>
    <path style="fill:#334D5C;" d="M140.273,323.458l-83.8,85.891c10.376,14.077,22.137,27.019,35.08,38.611l85.095-87.217
    C186.652,350.49,150.278,313.207,140.273,323.458z"/>
    <path style="opacity:0.3;fill:#5D5D5D;enable-background:new    ;" d="M176.221,360.744c10.003-10.254-26.1-47.537-36.104-37.285
    l-27.467,28.433v74.565L176.221,360.744z"/>
    <path style="fill:#EFC84A;" d="M182.104,369.131c-2.51,2.574-6.582,2.574-9.093,0l-41.377-42.41c-2.511-2.573-2.511-6.747,0-9.32
    l10.458-10.719c2.511-2.573,6.583-2.573,9.093,0l41.377,42.41c2.513,2.574,2.513,6.746,0,9.321L182.104,369.131z"/>

    </g>
  </svg>
</template>

<script>
export default {
  name: 'Research',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/Research.vue